import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, effect } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/components/base/confirm-dialog/confirm-dialog.component';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-profile-page',
  templateUrl: './user-profile-page.component.html',
  styleUrls: ['./user-profile-page.component.scss'],
})
export class UserProfilePageComponent implements OnInit, OnDestroy {
  breakpointsSubscription: Subscription;
  selfSubscription: Subscription;

  constructor(
    private user: UserService,
    private breakpointObserver: BreakpointObserver,
    public router: Router,
    private dialog: MatDialog,
    private api: UserApiService,
    private apiWork: WorkorderApiService,
    private notify: NotifyService
  ) {
    this.breakpointsSubscription = this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .subscribe((r) => {
        this.mobile = r.matches;
      });
    this.selfSubscription = this.user.events.subscribe((r) => {
      this.self = r;
    });

    //工单提醒
    effect(
      () => {
        const flag = this.notify.workorderSignal();
        if (flag === 0) {
          this.getNoReplyWorkorderCount();
        }
      },
      { allowSignalWrites: true }
    );
  }
  mobile = false;
  self: any;

  ngOnInit(): void {
    this.getSelf();
  }

  ngOnDestroy(): void {
    this.breakpointsSubscription.unsubscribe();
    this.selfSubscription.unsubscribe();
  }

  workorderNotificationCount = 0;
  async getNoReplyWorkorderCount() {
    try {
      const r = await this.apiWork.getNoReplyWorkorderCount();
      this.workorderNotificationCount = r.total || 0;
      this.notify.newWorkorder(r.total);
    } catch (error) {}
  }

  async getSelf() {
    try {
      this.self = await this.user.getSelf();
      if (!this.self) {
        this.router.navigateByUrl('/login', { replaceUrl: true });
      } else {
        this.getNoReplyWorkorderCount();
      }
    } catch (error) {}
  }

  logout() {
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        data: { text: '是否确认退出登录？' },
      })
      .afterClosed()
      .subscribe(async (r) => {
        if (r) {
          await this.api.logout();
          window.location.href = '/';
        }
      });
  }
}
